import React from "react";
import {connect} from "react-redux";
import DeleteConflictModal from "../components/delete-conflict-modal";
import EtlWizardDialog from "../components/etl-wizard";
import FabGroup from "../components/fab-group";
import {PackageManagerProvider} from "../components/package-manager";
import {HUB_EXTRAS_REGISTRATION_DISABLED} from "../components/settings-select/app-settings-form/constants";
import UserLoginDialog from "../components/user-login-dialog";
import UserSetPasswordDialog from "../components/user-set-password-dialog";
import Call from "../hocs/call";
import {fetchHub, fetchHubItemContainers} from "../state/hub/hubActions";
import {fetchUser, hideUserLoginForm, showUserRegisterModal} from "../state/user/userActions";

const mapStateToProps = state => ({
  hub: state.hub,
  user: state.user,
  moduleConfigs: state.moduleConfigs
});

const mapDispatchToProps = dispatch => ({
  fetchHub: () => dispatch(fetchHub()),
  fetchHubDashboards: () => dispatch(fetchHubItemContainers("dashboard")),
  fetchHubCustomPages: () => dispatch(fetchHubItemContainers("customPages")),
  onLoginHide: () => dispatch(hideUserLoginForm()),
  onLogin: (email, password) => dispatch(fetchUser(email, password)),
  onRegisterModalShow: () => dispatch(showUserRegisterModal())
});

const HubDomain = ({
  hub,
  user,
  moduleConfigs,
  fetchHub,
  fetchHubDashboards,
  fetchHubCustomPages,
  onLoginHide,
  onLogin,
  onRegisterModalShow,
  children
}) => (
  <Call cb={fetchHub} disabled={hub !== null}>
    <Call
      cb={fetchHubDashboards}
      disabled={!moduleConfigs.modules.includes("dashboard") || !hub || !!hub?.hub?.itemContainers?.dashboard}
    >
      <Call
        cb={fetchHubCustomPages}
        disabled={!moduleConfigs.modules.includes("custom-page") || !hub || !!hub?.hub?.itemContainers?.customPages}
      >
        {hub && (
          <PackageManagerProvider>
            <DeleteConflictModal />
            <UserSetPasswordDialog />
            <UserLoginDialog
              open={user.isLoginDialogOpen}
              onSubmit={({email, password}) => onLogin(email, password)}
              onRegister={onRegisterModalShow}
              onHide={onLoginHide}
              alert={user.message}
              alertSeverity={user.messageSeverity}
              loginOrHome={user.loginOrHome}
              disableRegistration={hub.hub?.extras?.Registration === HUB_EXTRAS_REGISTRATION_DISABLED}
            />
            <EtlWizardDialog />
            <FabGroup />
            {children}
          </PackageManagerProvider>
        )}
      </Call>
    </Call>
  </Call>
);

export default connect(mapStateToProps, mapDispatchToProps)(HubDomain);
